import {Injectable} from '@angular/core';
import {BaseService} from '../../../services/base.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {RootObject} from '../models/product';
import {User} from '../models/user';
import {environment} from '../../../environments/environment';
import {Cart} from '../models/CartModels/cart';
import {CartItem} from '../models/CartModels/cartItem';
import {AuthService} from '../../../services/auth.service';
import {Subject} from 'rxjs';
import {ProductService} from './product.service';
import {CustomerAddress} from '../models/CustomerInfo/CustomerAddress';
import {PaymentMethod} from '../models/CartModels/Checkout/PaymentMethod';
import {ShippingMethod} from '../models/CartModels/Checkout/ShippingMethod';
import {OrderSummary} from '../models/CartModels/Checkout/OrderSummary';
import {concatMap} from 'rxjs/operators';
import {of} from 'rxjs';

import {RegistryService} from './registry.service';

@Injectable({
    providedIn: 'root'
})
export class CartService extends BaseService {

    private CartUpdatedEventEmitter = new Subject<Cart>();
    private ShippingAddressUpdatedEventEmitter = new Subject<CustomerAddress>();
    private ShippingMethodUpdatedEventEmitter = new Subject<ShippingMethod>();
    private PaymentMethodUpdatedEventEmitter = new Subject<PaymentMethod>();
    private CartReadyEventEmitter = new Subject<any>();
    private CartSummaryReadyEventEmitter = new Subject<OrderSummary>();
    private OrderReadyEventEmitter = new Subject<boolean>();
    private ProductQtyUpdatedEventEmitter = new Subject<CartItem>();
    private QtyUpdatedEventEmitter = new Subject<number>();


    // observables
    public CartChangedEvent$ = this.CartUpdatedEventEmitter.asObservable();
    public ShippingAddressUpdatedEvent$ = this.ShippingAddressUpdatedEventEmitter.asObservable();
    public ShippingMethodUpdatedEvent$ = this.ShippingMethodUpdatedEventEmitter.asObservable();
    public PaymentMethodUpdatedEvent$ = this.PaymentMethodUpdatedEventEmitter.asObservable();
    public CartReadyEvent$ = this.CartReadyEventEmitter.asObservable();
    public CartSummaryReadyEvent$ = this.CartSummaryReadyEventEmitter.asObservable();
    public OrderReadyEvent$ = this.OrderReadyEventEmitter.asObservable();
    public ProductQtyUpdatedEvent$ = this.ProductQtyUpdatedEventEmitter.asObservable();
    public QtyUpdatedEvent$ = this.QtyUpdatedEventEmitter.asObservable();


    cart: Cart;
    selectedShippingAddress: CustomerAddress = null;
    selectedShippingMethod: ShippingMethod = null;
    selectedPaymentMethod: PaymentMethod = null;

    lastOrderId = null;

    constructor(private httpClient: HttpClient,
                private authService: AuthService,
                private productsService: ProductService
    ) {
        super();
    }

    getGuestCartQuote_id() {

        const serviceURL = this.baseAPI + 'guest-carts';
        return this.httpClient.post<any>(serviceURL, null, this.authService.getHttpOptions());
    }

    applyCartCode(Copon) {

        const serviceURL = this.baseAPI + 'carts/mine/coupons/';
        // const copon = [{'couponCode' : Copon}];
        return this.httpClient.put<any>(serviceURL + Copon, null, this.authService.getHttpOptions());
    }

    resetOrderSelections() {
        this.selectedPaymentMethod = null;
        this.selectedShippingAddress = null;
        this.selectedShippingMethod = null;
    }

    getGuestCart(Quote_id: string, website_id): Observable<Cart> {

        const serviceURL = this.baseAPI + 'guest-carts/' + Quote_id;
        // return this.httpClient.get<Cart>(serviceURL, this.authService.getHttpOptions());
        return this.httpClient.get<Cart>(serviceURL, this.authService.getHttpOptions()).pipe(
            concatMap(cart => {

                cart.quoteId = Quote_id;
                this.cart = cart;
                let items_cs = '';
                for (let i = 0; i < cart.items.length; i++) {
                    items_cs += cart.items[i].sku + ',';
                }
                items_cs = items_cs.substr(0, items_cs.length - 1); // removes last ","
                return this.productsService.ProductSearchAdv('sku', items_cs, 'in', 4, website_id);
            }),
            concatMap(response => {

                for (let i = 0; i < response.items.length; i++) {
                    for (let j = 0; j < this.cart.items.length; j++) {
                        if (this.cart.items[j].sku == response.items[i].sku) {
                            this.cart.items[j].product = response.items[i];
                        }
                    }
                }

                this.CartUpdatedEventEmitter.next(this.cart);
                return of(this.cart);
            })
        );


    }

    // loadGuestCartFull(cart: Cart) {
    //
    //     //load items_skus cs
    //     let items_cs = "";
    //
    //     for (let i = 0; i < cart.items.length; i++) {
    //         items_cs += cart.items[i].sku + ",";
    //     }
    //
    //     items_cs = items_cs.substr(0, items_cs.length - 1); //removes last ","
    //
    //     this.productsService.ProductSearchAdv('sku', items_cs, 'in').subscribe(response => {
    //
    //
    //         for (let i = 0; i < response.items.length; i++) {
    //             for (let j = 0; j < cart.items.length; j++) {
    //                 if (cart.items[j].sku == response.items[i].sku) {
    //                     cart.items[j].product = response.items[i];
    //                 }
    //             }
    //         }
    //         this.CartUpdatedEventEmitter.next(cart);
    //     });
    //
    // }

    addItemToCart(cart: Cart, sku: string, qty: number) {
        let serviceURL = '';
        let id = '';
        if (cart.cartType != 'user') {
            serviceURL = this.baseAPI + 'guest-carts/' + (String(cart.quoteId!)) + '/items';
            id = cart.quoteId ?? '';
        } else {
            serviceURL = this.baseAPI + 'carts/mine/items';
            id = String(cart.id!);
        }

        const params = {
            'cartItem': {
                'quote_id': id,
                'qty': qty,
                'sku': sku
            }
        };

        return this.httpClient.post<any>(serviceURL, params, this.authService.getHttpOptions());


    }


    getCustomerCart(website_id) {

        const serviceURL = this.baseAPI + 'carts/mine';
        return this.httpClient.get<Cart>(serviceURL, this.authService.getHttpOptions()).pipe(
            concatMap(cart => {
                cart.quoteId = String(cart.id);
                this.cart = cart;
                let items_cs = '';
                for (let i = 0; i < cart.items.length; i++) {
                    items_cs += cart.items[i].sku + ',';
                }
                items_cs = items_cs.substr(0, items_cs.length - 1); // removes last ","
                return this.productsService.ProductSearchAdv('sku', items_cs, 'in', 4, website_id);
            }),
            concatMap(response => {

                for (let i = 0; i < response.items.length; i++) {
                    for (let j = 0; j < this.cart.items.length; j++) {
                        if (this.cart.items[j].sku == response.items[i].sku) {
                            this.cart.items[j].product = response.items[i];
                        }
                    }
                }

                this.CartUpdatedEventEmitter.next(this.cart);
                return of(this.cart);
            })
        );
    }

    createCustomerCart() {

        const serviceURL = this.baseAPI + 'carts/mine';
        return this.httpClient.post<any>(serviceURL, {}, this.authService.getHttpOptions());

    }

    getCartItems(cart: Cart) {

        let serviceURL = '';

        if (cart.cartType == 'guest') {
            serviceURL = this.baseAPI + 'guest-carts/' + cart.quoteId + '/items';
        } else {
            serviceURL = this.baseAPI + 'carts/mine/items';
        }

        return this.httpClient.get<any>(serviceURL, this.authService.getHttpOptions());


    }

    deleteCartItem(cart: Cart, CartItemID: number) {

        let serviceURL = '';
        if (cart.cartType == 'guest') {
            serviceURL = this.baseAPI + 'guest-carts/' + (cart.quoteId!) + '/items/' + (CartItemID);
        } else {
            serviceURL = this.baseAPI + 'carts/mine/items/' + (CartItemID);
        }

        return this.httpClient.delete<any>(serviceURL, this.authService.getHttpOptions());

    }

    updateCartItemQty(user_type: string, item: CartItem, qoute_id: string) {

        let serviceURL = '';
        let method = '';
        let params = {};

        if (user_type == 'user') {
            serviceURL = this.baseAPI + 'carts/mine/items';

            params = {

                'cartItem': {
                    'item_id': item.item_id,
                    'qty': item.qty,
                    'quote_id': item.quote_id
                }
            };
            method = 'post';

        } else {

            serviceURL = this.baseAPI + 'guest-carts/' + qoute_id + '/items/' + String(item.item_id!);


            params = {

                'cartItem': {
                    'quote_id': qoute_id,
                    'qty': item.qty!,
                    'sku': item.sku
                }
            };

            method = 'put';
        }

        if (method == 'post') {
            return this.httpClient.post<any>(serviceURL, params, this.authService.getHttpOptions());
        } else if (method == 'put') {
            return this.httpClient.put<any>(serviceURL, params, this.authService.getHttpOptions());

        }

    }

    /**
     *
     * @param Address
     */
    loadShippingMethods(Address: CustomerAddress) {

        const serviceURL = this.baseAPI + 'carts/mine/estimate-shipping-methods';


        const params = {
                'address': {
                    'customer_id': Address.customerId,
                    'region_code': 40,
                    'region': Address.region?.region,
                    'region_id': Address.regionId,
                    'country_id': Address.country_id,
                    'street': Address.street,
                    'telephone': Address.telephone,
                    'postcode': Address.postcode,
                    'city': Address.city,
                    'firstname': Address.firstname,
                    'lastname': Address.lastname,
                    'email': '',
                }
            };


        return this.httpClient.post<any>(serviceURL, params, this.authService.getHttpOptions());

    }

    /**
     *
     * @param Address
     * @param selectedShippingMethod
     */
    getOrderSummary(Address: CustomerAddress, selectedShippingMethod: ShippingMethod) {

        const serviceURL = this.baseAPI + 'carts/mine/' + 'shipping-information';
        const params = {
                'addressInformation': {

                    'shipping_address': {
                        'region_code': Address.regionCode,
                        'region': Address.region?.region,
                        'region_id': Address.regionId,
                        'country_id': Address.country_id,
                        'street': Address.street,
                        'telephone': Address.telephone,
                        'postcode': Address.postcode,
                        'city': Address.city,
                        'firstname': Address.firstname,
                        'lastname': Address.lastname,
                        'email': ''

                    },

                    'billing_address': {
                        'region_code': Address.regionCode,
                        'region': Address.region?.region,
                        'region_id': Address.regionId,
                        'country_id': Address.country_id,
                        'street': Address.street,
                        'telephone': Address.telephone,
                        'postcode': Address.postcode,
                        'city': Address.city,
                        'firstname': Address.firstname,
                        'lastname': Address.lastname,
                        'email': '',
                    },
                    'shipping_carrier_code': selectedShippingMethod.carrier_code,
                    'shipping_method_code': selectedShippingMethod.method_code
                }
            };

        return this.httpClient.post<any>(serviceURL, params, this.authService.getHttpOptions());

    }

    /**
     *
     * @param billingAddress
     * @param selectedPaymentMethod
     */
    placeOrder(billingAddress: CustomerAddress, selectedPaymentMethod: PaymentMethod) {

        const serviceURL = this.baseAPI + 'carts/mine/' + 'payment-information';

        const params = {
                'paymentMethod': {
                    'method': selectedPaymentMethod.code ?? ''
                },
                'billing_address': {
                    'region_code': environment.defaultCountry,
                    'region': 'KW',
                    'region_id': '43',
                    'country_id': environment.defaultCountry,
                    'street': billingAddress.street,
                    'telephone': billingAddress.telephone,
                    'postcode': billingAddress.postcode,
                    'city': billingAddress.city,
                    'firstname': billingAddress.firstname,
                    'lastname': billingAddress.lastname,
                    'email': '',
                }
            };

        return this.httpClient.post<any>(serviceURL, params, this.authService.getHttpOptions());
    }

    loadOrderRestrictions(storeview = null) {


        let serviceURL = this.baseAPI2 + '/mage/order/restrictions';
        let obj = {
            'storeview': storeview
        };
        return this.httpClient.post<any>(serviceURL, obj,this.authService.getHttpOptions());

    }



    setCachedCartId(customerType, cartId) {
        localStorage.setItem('customer_type', customerType);
        localStorage.setItem('cartId', cartId);
    }

    getCachedCartId() {
        const qid = localStorage.getItem('cartId');
        return qid;
    }

    checkCartReady() {

        if (this.selectedShippingMethod != null && this.selectedShippingAddress != null && this.cart.items.length > 0) {
            this.EmitCartReady();
        }

    }

    checkOrderReady() {

        console.log(this.selectedShippingMethod , this.selectedShippingAddress , this.selectedPaymentMethod , this.cart?.items?.length > 0)

        if (this.selectedShippingMethod != null && this.selectedShippingAddress != null && this.selectedPaymentMethod != null && this.cart?.items?.length > 0) {
            this.EmitOrderReady(true);
        } else {
            this.EmitOrderReady(false);
        }

    }

    isCheckOrderReady() {

        if (this.selectedShippingMethod != null && this.selectedShippingAddress != null && this.selectedPaymentMethod != null && this.cart.items.length > 0) {
            return true;
        } else {
            return false;
        }

    }

    /************Events Init****************/
    EmitCartUpdated(cart: Cart) {
        this.CartUpdatedEventEmitter.next(cart);
    }

    EmitShippingAddressUpdated(address: CustomerAddress) {
        this.ShippingAddressUpdatedEventEmitter.next(address);
    }

    EmitShippingMethodUpdated(method: ShippingMethod) {
        this.ShippingMethodUpdatedEventEmitter.next(method);
    }

    EmitPaymentMethodUpdated(method: PaymentMethod) {
        this.PaymentMethodUpdatedEventEmitter.next(method);
    }

    EmitCartReady() {
        this.CartReadyEventEmitter.next();
    }

    EmitCartSummaryReady(summary_data: OrderSummary) {
        this.CartSummaryReadyEventEmitter.next(summary_data);
    }

    EmitOrderReady(result: boolean) {
        this.OrderReadyEventEmitter.next(result);
    }

    EmitProductQtyUpdated(item: CartItem) {
        this.ProductQtyUpdatedEventEmitter.next(item);
    }

    EmitQtyUpdated(qty: number) {
        this.QtyUpdatedEventEmitter.next(qty);
    }

}
